export default __webpack_public_path__ + "static/media/undraw-html-email-capture.1dedb0a1.svg";